export default __webpack_public_path__ + "static/media/undraw_profile_details_f8b7.df49225e.svg";